import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85c05ff0")

_pushScopeId("data-v-85c05ff0")
const _hoisted_1 = {
  ref: "wrapperRef",
  class: "custom-select-wrapper"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      disabled: _ctx.disabled,
      type: "button",
      class: "select-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, _toDisplayString(_ctx.selectedLabel), 9, ["disabled"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock("ul", {
            key: 0,
            class: "options-list",
            role: "listbox",
            style: _ctx.dropdownStyles
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createBlock("li", {
                key: option.value,
                class: "option-item",
                onClick: ($event: any) => (_ctx.handleSelect(option)),
                role: "option"
              }, _toDisplayString(option.label), 9, ["onClick"]))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
})